module.exports = __webpack_public_path__ + "img/md-female.01eebeb5.svg";